var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "confirm_alert-gerencia_request",
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c(
            "div",
            { class: "modal-content shadow " + _vm.confirm_alert_class },
            [
              _c("div", { staticClass: "modal-body" }, [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.confirm_alert_content) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row pt-3" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-block btn-light",
                        attrs: {
                          "data-toggle": "modal",
                          "data-target": "#confirm_alert-gerencia_request",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.declineConfirmAlert(
                              _vm.confirm_alert_request
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            Não\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "button",
                      {
                        class: _vm.confirm_alert_btn
                          ? _vm.confirm_alert_btn
                          : "btn btn-sm btn-block btn-secondary",
                        on: {
                          click: function ($event) {
                            return _vm.requestConfirmAlert(
                              _vm.confirm_alert_request
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            Sim\n                        "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }